import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"

import {Wrapper, Paragraph} from "../../../components/Polls/Empty/styled/Feed"
import image from "../../../images/vote-empty.png"

const StyledWrapper = styled(Wrapper)`
  box-shadow: none;
  border: none;
`

const ICON_SIZE = 120

const VoteIcon = styled.img.attrs({
  alt: "trophy",
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  src: image
})`
  margin-bottom: 30px;
`

export default class EmptyRecognitions extends PureComponent {
  static propTypes = {
    votes: PropTypes.bool
  }

  static defaultProps = {
    votes: false
  }

  render() {
    const {votes} = this.props
    return (
      <StyledWrapper>
        <VoteIcon />
        <Paragraph>
          {votes
            ? <FormattedMessage id="recognition.account.votes.empty" />
            : <FormattedMessage id="recognition.account.recognition.empty" />
          }
        </Paragraph>
      </StyledWrapper>
    )
  }
}
